/**
 *  @description
 *  Private route
 *  @author
 *  Mahesh Hegde<mahesh&#64;innocirc.com>
 *  @version
 *  1.0.0 (18-Dec-2018)
 */

import React from 'react';
import { Route, Redirect } from 'react-router';

const PrivateRoute = ({component: Component, isPaired, ...rest}) => (
    <Route 
        {...rest}
        render={props => (
            isPaired
            ? <Component {...props} />
            : <Redirect to="/" />
        )}
    />
);

export default PrivateRoute;
